import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'a360-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InfoModalComponent {
  @Input() public title: string;
  @Input() public text: string;
  @Input() public textHeading: string;
  @Input() public textBold: string;
  @Input() public textHtml: string;
  @Input() public textAlignLeft = false;
  @Input() public closeText: string;
  @Input() public closeInfoContent: string;
  @Input() public confirm;

  @Input()
  @HostBinding('class.grey')
  public hasClose = false;

  constructor(public bsModalRef: BsModalRef) {}

  public onConfirm(): void {
    this.bsModalRef.hide();
    if (this.confirm && typeof this.confirm === 'function') {
      this.confirm();
    }
  }

  public close(): void {
    this.bsModalRef.hide();
  }
}
